import React from "react";
import Modal from "../../ui-components/Modal";
import { useIntl, FormattedMessage } from "react-intl";
import { EnvelopeIcon } from "@heroicons/react/24/outline";

function KerakollContactsModal({ closeModal, userData }) {
  const intl = useIntl();

  return (
    <Modal onExit={closeModal}>
      <div className="flex w-full flex-col h-full">
        <label className="block text-lg font-bold mb-5">
          <FormattedMessage id="kerakoll_contacts" />
        </label>
        {Object.entries(userData.ref_users).map(([key, refUser]) => {
          return (
            <div className="m-3" key={key}>
              <p className="font-bold">{intl.formatMessage({ id: key })}</p>
              <span className="text-xxs italic">
                {intl.formatMessage({ id: `${key}_desc` })}
              </span>
              {Object.entries(refUser).map(([key, user]) => (
                <div key={key}>
                  <p className="m-3">{user.name}</p>
                  <p className="ml-3">
                    <a
                      className="text-am-500 italic"
                      href={"mailto:" + user.email}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <EnvelopeIcon
                        className="mr-2 h-5 w-5 inline-block"
                        aria-hidden="true"
                      />
                      {user.email}
                    </a>
                  </p>
                </div>
              ))}
            </div>
          );
        })}
      </div>
    </Modal>
  );
}

export default KerakollContactsModal;
